import { Button } from '@bloomfieldrobotics/canopy';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { useTranslation } from '../../../services/translation/hooks/useTranslation';
import {
  selectDebugCurrCollectionId,
  setDebugRefreshTrigger,
} from '../debugSlice';
/**
 * A refresh button component that triggers data refetching for all debug collection related queries
 */
export const CollectionDebugRefreshButton = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const collectionId = useAppSelector(selectDebugCurrCollectionId);
  const [isRefreshing, setIsRefreshing] = useState(false);

  const handleRefresh = async () => {
    if (!collectionId || isRefreshing) return;

    setIsRefreshing(true);
    try {
      // Dispatch an action with a timestamp to trigger refetches
      dispatch(setDebugRefreshTrigger(Date.now()));
    } finally {
      // Set refreshing back to false after a short delay
      // to allow the UI to show the refreshing state
      setTimeout(() => {
        setIsRefreshing(false);
      }, 500);
    }
  };

  return (
    <Button
      variant='outlined'
      color='primary'
      size='small'
      onClick={handleRefresh}
      disabled={isRefreshing || !collectionId}
      startIcon={<RefreshIcon />}
    >
      {isRefreshing ? t('Refreshing...') : t('Refresh Data')}
    </Button>
  );
};
